import { render, staticRenderFns } from "./SignatureSheetsTable.vue?vue&type=template&id=054e90d9"
import script from "./SignatureSheetsTable.vue?vue&type=script&lang=js"
export * from "./SignatureSheetsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports